import React from "react";
import { logEvent } from "../../utils/logger";

/**
 * ErrorBoundary global — attrape les crashs de l'arbre React entier.
 * Déclenche un log CRITICAL qui envoie un SMS/Email en temps réel.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logEvent("CRITICAL", "UI", "React Tree Crashed", {
      error: error.toString(),
      errorMessage: error.message,
      errorStack: error.stack,
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            padding: "20px",
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          <h2 style={{ marginBottom: "10px" }}>Une erreur est survenue</h2>
          <p style={{ color: "#666", marginBottom: "20px" }}>
            L'application a rencontré un problème. Veuillez rafraîchir la page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 24px",
              border: "none",
              borderRadius: "8px",
              backgroundColor: "#333",
              color: "#fff",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Rafraîchir
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
